<template>
  <div class="about-us">
    <!-- 顶部banner -->
    <div class="banner">
      <div class="banner-content">
        <h1>GET TO KNOW US</h1>
        <p>了解我们</p>
      </div>
    </div>
    
    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="nav-container">
        <div 
          v-for="(item, index) in visibleNavItems" 
          :key="item.key" 
          class="nav-item"
          :class="{ active: activeNav == index }"
          @click="scrollToSection(index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    
    <!-- 公司简介 -->
    <div ref="section-0" v-if="aboutUsData.companyProfileStatus == 1" class="section company-intro">
      <div class="container">
        <h2 class="section-title">公司简介</h2>
        <div class="intro-wrapper">
           <div class="stats-wrapper" v-if="aboutUsData.companyContentList && aboutUsData.companyContentList.length > 0">
            <div class="stat-item" v-for="(stat, index) in aboutUsData.companyContentList" :key="index">
              <div class="stat-value">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.key }}</div>
            </div>
          </div>
          <div class="intro-content" v-html="aboutUsData.companyProfile"></div>
         
        </div>
      </div>
    </div>
    
    <!-- 核心优势 -->
    <div ref="section-1" v-if="aboutUsData.coreStrengthsStatus == 1" class="section core-advantages">
      <div class="container">
        <h2 class="section-title">核心优势</h2>
        <div class="advantages-wrapper">
          <div class="advantage-item" v-for="(item, index) in aboutUsData.coreStrengthsVos" :key="index">
            <h3 class="advantage-title">{{ item.key }}</h3>
            <div class="advantage-content" v-html="item.value"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 发展历程 -->
    <div ref="section-2" v-if="aboutUsData.developmentHistoryStatus == 1" class="section development-history">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <div class="history-wrapper" v-if="aboutUsData.developmentHistoryVos && aboutUsData.developmentHistoryVos.length > 0">
          <div class="arrow arrow-left" @click="scrollHistory('left')">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15,18 9,12 15,6"></polyline>
            </svg>
          </div>
          <div class="history-timeline" ref="timelineRef">
            <div class="timeline-line"></div>
            <div class="history-items" :style="{ transform: `translateX(${timelineOffset}px)` }">
              <div class="history-item" v-for="(item, index) in aboutUsData.developmentHistoryVos" :key="index">
                <div class="history-dot" :class="{ active: index == activeHistoryIndex }"></div>
                <div class="history-year" :class="{ active: index == activeHistoryIndex }">{{ item.key }}</div>
                <div class="history-card" :class="{ active: index == activeHistoryIndex, 'top-card': index % 2 == 0, 'bottom-card': index % 2 !== 0 }">
            <div class="history-card-bg-year">{{ item.key }}</div>
            <div class="history-card-year">{{ item.key }}</div>
            <div class="history-content" v-html="item.value"></div>
          </div>
              </div>
            </div>
          </div>
          <div class="arrow arrow-right" @click="scrollHistory('right')">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9,18 15,12 9,6"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 联系我们 -->
    <div v-if="aboutUsData.contactUsStatus == 1" class="section contact-us" >
      <div class="container" style="width: 900px;">
        <div class="contact-wrapper">
          <div class="contact-info">
            <h2 class="section-title">联系我们</h2>
            <div class="contact-item" v-if="aboutUsData.contactUsPhone">
              <span class="contact-label">电话：</span>
              <span class="contact-value">{{ aboutUsData.contactUsPhone }}</span>
            </div>
            <div class="contact-item" v-if="aboutUsData.email">
              <span class="contact-label">邮箱：</span>
              <span class="contact-value">{{ aboutUsData.email }}</span>
            </div>
            <div class="contact-item" v-if="aboutUsData.weChat">
              <span class="contact-label">微信：</span>
              <span class="contact-value">{{ aboutUsData.weChat }}</span>
            </div>
            <div class="contact-item" v-if="aboutUsData.address">
              <span class="contact-label">地址：</span>
              <span class="contact-value">{{ aboutUsData.address }}</span>
            </div>
          </div>
          <div class="contact-image" v-if="aboutUsData.contactUsImg">
            <img :src="aboutUsData.contactUsImg" alt="联系我们">
            <div class="bottom-content" v-if="aboutUsData.contactUsContent" v-html="aboutUsData.contactUsContent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeClient } from "@/api/home";

export default {
  name: 'AboutUs',
  data() {
    return {
      homeClient: new HomeClient(),
      aboutUsData: {
        companyProfile: '',
        companyProfileStatus: 1,
        companyContentList: [],
        coreStrengthsVos: [],
        coreStrengthsStatus: 1,
        developmentHistoryVos: [],
        developmentHistoryStatus: 1,
        contactUsStatus: 1,
        contactUsPhone: '',
        email: '',
        weChat: '',
        address: '',
        contactUsContent: '',
        contactUsImg: ''
      },
      sectionConfigs: [
        { key: 'companyProfile', label: '公司简介', status: 'companyProfileStatus' },
        { key: 'coreStrengths', label: '核心优势', status: 'coreStrengthsStatus' },
        { key: 'developmentHistory', label: '发展历程', status: 'developmentHistoryStatus' }
      ],
      activeNav: 0,
      activeHistoryIndex: 0,
      timelineOffset: 0
    }
  },
  computed: {
    visibleNavItems() {
      return this.sectionConfigs.filter(config => this.aboutUsData[config.status] == 1);
    }
  },
  async created() {
    await this.getAboutUsData();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async getAboutUsData() {
      try {
        const res = await this.homeClient.getAboutUsConfig();
        if (res && res.data) {
          this.aboutUsData = res.data;
          // 确保 activeNav 在有效范围内
          this.$nextTick(() => {
            if (this.visibleNavItems.length > 0 && this.activeNav >= this.visibleNavItems.length) {
              this.activeNav = 0;
            }
          });
          // 按年份排序
          if (this.aboutUsData.developmentHistoryVos && this.aboutUsData.developmentHistoryVos.length > 0) {
            this.aboutUsData.developmentHistoryVos.sort((a, b) => {
              // 提取年份，假设key是年份字符串
              const yearA = parseInt(a.key);
              const yearB = parseInt(b.key);
              return yearA - yearB; // 升序排列，从小到大
            });
            // 默认选中中间的年份
            this.activeHistoryIndex = Math.floor(this.aboutUsData.developmentHistoryVos.length / 2);
            // 等待DOM更新后滚动到中间项
            this.$nextTick(() => {
              setTimeout(() => {
                this.scrollToActiveItem();
              }, 300);
            });
          }
        }
      } catch (error) {
        console.error('获取关于我们数据失败:', error);
      }
    },
    scrollToSection(visibleIndex) {
      this.activeNav = visibleIndex;
      const visibleItem = this.visibleNavItems[visibleIndex];
      const originalIndex = this.sectionConfigs.findIndex(config => config.key == visibleItem.key);
      const section = this.$refs['section-' + originalIndex];
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY + 100;
      for (let i = this.visibleNavItems.length - 1; i >= 0; i--) {
        const visibleItem = this.visibleNavItems[i];
        const originalIndex = this.sectionConfigs.findIndex(config => config.key == visibleItem.key);
        const section = this.$refs['section-' + originalIndex];
        if (section && section.offsetTop <= scrollPosition) {
          this.activeNav = i;
          break;
        }
      }
    },
    scrollHistory(direction) {
      const maxIndex = this.aboutUsData.developmentHistoryVos.length - 1;
      if (direction == 'left' && this.activeHistoryIndex > 0) {
        this.activeHistoryIndex--;
      } else if (direction == 'right' && this.activeHistoryIndex < maxIndex) {
        this.activeHistoryIndex++;
      }
      this.scrollToActiveItem();
    },
    scrollToActiveItem() {
      this.$nextTick(() => {
        const timeline = this.$refs.timelineRef;
        if (timeline) {
          const items = timeline.querySelectorAll('.history-item');
          if (items[this.activeHistoryIndex]) {
            const timelineRect = timeline.getBoundingClientRect();
            const itemRect = items[this.activeHistoryIndex].getBoundingClientRect();
            const itemCenter = itemRect.left + itemRect.width / 2;
            const timelineCenter = timelineRect.left + timelineRect.width / 2;
            this.timelineOffset -= (itemCenter - timelineCenter);
          }
        }
      });
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.about-us {
  --primary-color: #1890ff;
  --primary-dark: #096dd9;
  --text-primary: #303133;
  --text-secondary: #606266;
  --text-tertiary: #909399;
  --border-color: #e8e8e8;
  --bg-light: #f5f7fa;
  --bg-white: #ffffff;
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 2px 12px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 4px 20px rgba(0, 0, 0, 0.06);
  --shadow-primary: 0 8px 24px rgba(24, 144, 255, 0.3);
  --transition-fast: 0.3s ease;
  --transition-slow: 0.5s ease;
  --border-radius-sm: 4px;
  --border-radius-md: 8px;
  --border-radius-lg: 12px;
  --max-width: 1200px;
  --section-padding: 40px;
  --container-padding: 20px;

  width: 100%;
  
  .banner {
    width: 100%;
    height: 400px;
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/lz/99.png') no-repeat center center/cover;
    
    .banner-content {
      text-align: center;
      color: var(--bg-white);
      
      h1 {
        font-size: 48px;
        margin-bottom: 10px;
        letter-spacing: 4px;
      }
      
      p {
        font-size: 24px;
        opacity: 0.9;
      }
    }
  }
  
  .nav-bar {
    width: 100%;
    background: var(--bg-white);
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: var(--shadow-sm);
    
    .nav-container {
      max-width: var(--max-width);
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 var(--container-padding);
      
      .nav-item {
        padding: 16px 40px 16px 0;
        font-size: 16px;
        color: var(--text-secondary);
        cursor: pointer;
        position: relative;
        transition: all var(--transition-fast);
        
        &:hover {
          color: var(--primary-color);
        }
        
        &.active {
          color: var(--primary-color);
          font-weight: 600;
          
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 40px;
            height: 3px;
            background: var(--primary-color);
            border-radius: var(--border-radius-sm);
          }
        }
      }
    }
  }
  
  .section {
    padding: var(--section-padding) 0;
  }
  
  .container {
    max-width: var(--max-width);
    margin: 0 auto;
    padding: 0 var(--container-padding);
  }
  
  .section-title {
    text-align: center;
    font-size: 32px;
    color: var(--text-primary);
    margin-bottom: 60px;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background: var(--primary-color);
    }
  }
  
  .company-intro {
    .intro-wrapper {
      display: flex;
      flex-direction: column;
      gap: 40px;
    }
    
    .intro-content {
      font-size: 16px;
      line-height: 2;
      color: var(--text-secondary);
      padding: 30px;
      background: linear-gradient(135deg, #f8fafc 0%, var(--bg-white) 100%);
      border-radius: var(--border-radius-lg);
      box-shadow: var(--shadow-lg);
      border-left: 4px solid var(--primary-color);
    }
    
    .stats-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
      gap: 20px;
      
      .stat-item {
        text-align: center;
        padding: 24px 20px;
        background: var(--bg-white);
        border-radius: var(--border-radius-lg);
        box-shadow: var(--shadow-md);
        transition: all var(--transition-fast);
        cursor: pointer;
        
        &:hover {
          background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
          transform: translateY(-4px);
          box-shadow: var(--shadow-primary);
          
          .stat-value,
          .stat-label {
            color: var(--bg-white);
          }
          
          .stat-label {
            opacity: 0.9;
          }
        }
        
        .stat-value {
          font-size: 32px;
          font-weight: 700;
          color: var(--primary-color);
          margin-bottom: 10px;
          transition: color var(--transition-fast);
        }
        
        .stat-label {
          font-size: 14px;
          color: var(--text-secondary);
          font-weight: 500;
          transition: color var(--transition-fast), opacity var(--transition-fast);
        }
      }
    }
  }
  
  .core-advantages {
    background: var(--bg-light);
    
    .advantages-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 30px;
      
      .advantage-item {
        background: var(--bg-white);
        padding: 40px;
        border-radius: var(--border-radius-lg);
        box-shadow: var(--shadow-md);
        transition: all var(--transition-fast);
        cursor: pointer;
        
        &:hover {
          background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
          transform: translateY(-4px);
          box-shadow: var(--shadow-primary);
          
          .advantage-title,
          .advantage-content {
            color: var(--bg-white);
          }
        }
        
        .advantage-title {
          font-size: 20px;
          font-weight: 600;
          color: #0653C6;
          margin-bottom: 20px;
          transition: color var(--transition-fast);
        }
        
        .advantage-content {
          font-size: 20px;
          line-height: 1.5;
          color: var(--text-secondary);
          transition: color var(--transition-fast);
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  
  .development-history {
    background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/lz/999.png') no-repeat center center/cover;
    .history-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      gap: 20px;
    }
    
    .arrow {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: var(--bg-white);
      border: 2px solid var(--primary-color);
      color: var(--primary-color);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all var(--transition-fast);
      flex-shrink: 0;
      z-index: 10;
      
      &:hover {
        background: var(--primary-color);
        color: var(--bg-white);
      }
      
      svg {
        width: 24px;
        height: 24px;
      }
    }
    
    .history-timeline {
      position: relative;
      flex: 1;
      overflow-x: hidden;
      padding: 120px 0;
      overflow-y: visible;
      min-height: 400px;
      
      .timeline-line {
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        height: 3px;
        background: linear-gradient(90deg, var(--border-color) 0%, var(--primary-color) 50%, var(--border-color) 100%);
        transform: translateY(-50%);
      }
      
      .history-items {
        display: flex;
        gap: 80px;
        padding: 0 500px;
        position: relative;
        transition: transform var(--transition-slow);
        
        .history-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          flex-shrink: 0;
          width: 260px;
          height: 320px;
          
          .history-dot {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: var(--bg-white);
            border: 4px solid var(--border-color);
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 2;
            transition: all var(--transition-fast);
            
            &.active {
              background: var(--primary-color);
              border-color: var(--primary-color);
              box-shadow: 0 0 0 6px rgba(24, 144, 255, 0.2);
            }
          }
          
          .history-year {
            position: absolute;
            top: calc(50% + 45px);
            font-size: 18px;
            font-weight: 600;
            color: var(--text-tertiary);
            transition: all var(--transition-fast);
            
            &.active {
              color: var(--primary-color);
              font-size: 20px;
            }
          }
          
          .history-card {
            width: 220px;
            padding: 15px 15px 12px;
            background: var(--bg-white);
            border: 2px solid var(--border-color);
            border-radius: var(--border-radius-sm);
            position: absolute;
            transition: all var(--transition-fast);
            display: flex;
            overflow: hidden;
            
            &.top-card {
              bottom: calc(50% + 45px);
              flex-direction: column;
            }
            
            &.bottom-card {
              top: calc(50% + 75px);
              flex-direction: column-reverse;
            }
            
            &.active {
              border-color: var(--primary-color);
              background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
              color: var(--bg-white);
              transform: scale(1.05);
              box-shadow: var(--shadow-primary);
              
              .history-card-year {
                color: var(--bg-white);
              }
              
              .history-card-bg-year {
                color: rgba(255, 255, 255, 0.15);
              }
              
              .history-content {
                color: rgba(255, 255, 255, 0.9);
              }
            }
            
            .history-card-bg-year {
              position: absolute;
              left: 50%;
              transform: translateX(-50%); 
              font-size: 64px;
              font-weight: 800;
              color: rgba(144, 147, 153, 0.15);
              line-height: 1;
              z-index: 0;
              pointer-events: none;
            }
            
            &.top-card .history-card-bg-year {
              top: -0px;
              bottom: auto;
            }
            
            &.bottom-card .history-card-bg-year {
              bottom: -0px;
              top: auto;
            }
            
            .history-card-year {
              font-size: 36px;
              font-weight: 800;
              color: var(--text-primary);
              margin-top: 8px;
              transition: color var(--transition-fast);
              text-align: center;
              line-height: 1;
              z-index: 1;
            }
            
            &.bottom-card .history-card-year {
              margin-top: 0;
              margin-bottom: 8px;
            }
            
            .history-content {
              font-size: 14px;
              line-height: 1.6;
              color: var(--text-secondary);
              transition: color var(--transition-fast);
              word-wrap: break-word;
              overflow-wrap: break-word;
              text-align: center;
              z-index: 1;
              position: relative;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  
  .contact-us {
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
    color: var(--bg-white);
    
    .section-title {
      color: var(--bg-white);
      text-align: left;
      
      &::after {
        background: var(--bg-white);
        left: 0;
        transform: none;
      }
    }
    
    .contact-wrapper {
      display: flex;
      gap: 60px;
      align-items: center;
    }
    
    .contact-info {
      flex: 1;
      
      .contact-item {
        margin-bottom: 20px;
        font-size: 16px;
        
        .contact-label {
          font-weight: bold;
          margin-right: 10px;
        }
      }
     
    }
    
    .contact-image {
      flex-shrink: 0; 
      height: 100%;
      
      img {
        width: 175px;
        height: 175px;
        border-radius: var(--border-radius-md);
      }
       
      .bottom-content {
        margin-top: 10px;  
        font-size: 14px; 
        text-align: center;
        
        p{
          text-align: center;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .about-us {
    --section-padding: 60px;
    
    .banner {
      height: 250px;
      
      .banner-content h1 {
        font-size: 28px;
      }
      
      .banner-content p {
        font-size: 18px;
      }
    }
    
    .nav-bar {
      .nav-container {
        .nav-item {
          padding: 12px 20px;
          font-size: 14px;
        }
      }
    }
    
    .development-history {
      .history-wrapper {
        flex-direction: column;
        gap: 20px;
      }
      
      .arrow {
        display: none;
      }
      
      .history-timeline {
        width: 100%;
        padding: 80px 0;
        min-height: 300px;
        
        .history-items {
          gap: 60px;
          padding: 0 300px;
          
          .history-item {
            width: 220px;
            height: 280px;
            
            .history-card {
              width: 180px;
              padding: 12px 12px 10px;
              
              &.top-card {
                flex-direction: column;
              }
              
              &.bottom-card {
                flex-direction: column-reverse;
              }
              
              .history-card-bg-year {
                font-size: 60px;
              }
              
              &.top-card .history-card-bg-year {
                top: -8px;
                bottom: auto;
              }
              
              &.bottom-card .history-card-bg-year {
                bottom: -8px;
                top: auto;
              }
              
              .history-card-year {
                font-size: 32px;
              }
              
              &.bottom-card .history-card-year {
                margin-top: 0;
                margin-bottom: 8px;
              }
              
              .history-content {
                font-size: 13px;
                line-height: 1.5;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
    
    .contact-us .contact-wrapper {
      flex-direction: column;
    }
  }
}
</style>